import { ModbusReturnedDataType } from '@thingslog/repositories';

export const modbusReturnedDataTypeOptions: ModbusReturnedDataType[] = [
  'HEX',
  'UINT16',
  'INT16',
  'UINT32',
  'INT32',
  'UINT64',
  'INT64',
  'FLOAT32',
  'FLOAT64',
  'STRING',
  'BITMASK',
  'COMPOSITE_DECIMAL',
];
